import useSWR, { SWRResponse, SWRConfiguration } from 'swr';
import { AxiosError } from 'axios';
import { MarketingDesignAutofillJob } from '../../../providers/api/dtos';
import { API_MARKETING_PATH } from '../../../providers/api/api';
import { getMarketingDesignAutofillJob } from '../../../providers/api/marketing/marketingProvider';

export const MARKETING_DESIGN_AUTOFILL_JOB_RID = `${API_MARKETING_PATH}/jobs/autofills`;

export default function useMarketingDesignAutofillJob(
  jobId?: string,
  options?: SWRConfiguration<MarketingDesignAutofillJob, AxiosError>,
): SWRResponse<MarketingDesignAutofillJob, AxiosError> {
  const key = jobId ? [MARKETING_DESIGN_AUTOFILL_JOB_RID, jobId] : null;

  return useSWR(key, () => getMarketingDesignAutofillJob(jobId!), options);
}
